"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Navbar = ({ children }) => core_1.jsx("div", { className: styles_scss_1.default.navbar },
    " ",
    children,
    " ");
Navbar.defaultProps = {
    children: undefined,
};
const Nav = ({ children, }) => core_1.jsx("div", { className: styles_scss_1.default.nav }, children);
Nav.defaultProps = {
    children: undefined,
};
const Brand = ({ logo }) => core_1.jsx("img", { className: styles_scss_1.default.brand, src: logo, alt: "Logo" });
Navbar.Nav = Nav;
Navbar.Brand = Brand;
exports.default = Navbar;
